import React, { useEffect, useState } from "react";
import { MdOutlineSaveAlt } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { showPositionAction } from "../../Actions/BranchAction/PageAction";
import {
  createPermissionAction,
  showPermissionAction,
  updatePermissionAction,
} from "../../Actions/BranchAction/PermissionAction";
import LoadingPage from "../Loading/LoadingPage";

const EditRolePage = () => {
  const { id, roleName } = useParams();
  const dispatch = useDispatch();
  const showPage = useSelector((state) => state.showPage);
  const { pages, loading } = showPage;

  const showPermission = useSelector((state) => state.showPermission);
  const { permissions } = showPermission;
  const [state, setState] = useState({
    roleName: roleName,
    positionId: "",
    branchId: "",
  });
  const handleStateChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };
  useEffect(() => {
    dispatch(showPermissionAction(id));
  }, []);
  useEffect(() => {
    dispatch(showPositionAction());
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();

    let permissionIds = [];
    if (permissions?.length > 0) {
      permissions.map((item) => {
        permissionIds.push(item.id);
      });
    }

    if (permissionIds.length > 0) {
      dispatch(
        updatePermissionAction(
          toggleStates,

          id,
          permissionIds
        )
      );
      return;
    } else {
      dispatch(createPermissionAction(toggleStates, id));
    }
  };
  const [toggleStates, setToggleStates] = useState([]);
  useEffect(() => {
    if (permissions?.length > 0) {
      const permissionState = permissions?.map((page) => ({
        id: page?.page_id,
        isToggled: page?.permission == 1 ? true : false,
        route: page?.route,
      }));
      setToggleStates(permissionState);
      return;
    } else {
      const initialToggleState = pages?.map((page) => ({
        id: page.id,
        isToggled: false,
        route: null,
      }));

      setToggleStates(initialToggleState);
      return;
    }
  }, [loading, permissions]);

  const handleToggle = (id, e) => {
    const targetName = e.target.name.replace(/\s+/g, "");
    // console.log(targetName);
    const newToggleStates = toggleStates?.map((item) => {
      if (item.id === id) {
        return { ...item, isToggled: e.target.checked, route: targetName };
      }
      if (item.id != id) {
        return { ...item };
      }
    });

    setToggleStates(newToggleStates);
  };

  return (
    <>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="bg-white w-11/12 m-auto mt-2 py-4 rounded-sm">
          <form
            onSubmit={handleSubmit}
            action=""
            className="flex flex-col m-auto mt-auto justify-center "
          >
            <div className="flex flex-col gap-0  w-11/12   m-auto  ">
              <label htmlFor="">Role Name *</label>
              <input
                onChange={handleStateChange}
                type="text"
                name="roleName"
                value={state.roleName}
                placeholder="Name"
                className="input"
              />
            </div>

            <div className="w-11/12 m-auto ">
              <hr />

              <div className="lg:w-4/12     my-4 ">
                {pages?.map((page, index) => (
                  <React.Fragment key={index}>
                    <Title page={page} index={index} />

                    <div
                      key={page.id}
                      className="flex gap-2  justify-between items-center my-4"
                    >
                      <p>{page.name}</p>

                      <label className="switch">
                        <input
                          type="checkbox"
                          name={page?.name}
                          checked={
                            toggleStates.length > 0
                              ? toggleStates[index]?.isToggled
                              : ""
                          }
                          onChange={(e) => handleToggle(page.id, e)}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>

            <div className="w-11/12 mt-2  m-auto">
              <button
                type="submit"
                className="btn-info  flex gap-2   items-center"
              >
                Save <MdOutlineSaveAlt />
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

function Title({ page, index }) {
  return (
    <div>
      {page.id >= 1 && page.id <= 16 && index == 0 ? (
        <>
          <div className="bg-indigo-600 my-2 p-2 text-gray-100 rounded-md shadow-md">
            Patient Page
          </div>
        </>
      ) : page.id >= 17 && page.id <= 18 && index == 16 ? (
        <>
          <div className="bg-green-600 p-2 text-gray-100  rounded-md shadow-md">
            Media Page
          </div>
        </>
      ) : page.id >= 19 && page.id <= 21 && index == 18 ? (
        <>
          <div className="bg-blue-600 p-2 text-gray-100  rounded-md shadow-md">
            Hr Page
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
}

export default EditRolePage;
